export default __webpack_public_path__ + "static/hero-code-df02e435ad2c57f53bc8c5548dbba3f1.jpg";